import React, { ReactNode } from 'react';
import { APIKeys } from '../chat/apikeys';
import { ChatList } from '../chat/chatlist';
import { ModelListComp } from '../chat/modellistcomp';
import { ToolBar, Direction } from '../toolbar';
import { Conversation } from '../../../fasades/conversation';
import { ChatComponent, Mode } from '../chat/chatcomponent';
import { ModelList } from '../../../fasades/modellist';
import { RoundButton } from '../roundbutton';
import { Header } from './Header';
import { IModel, IState } from '../../api/llmapi';
import { ModelSelect } from '../chat/modelselect';
import { IoMdAdd, IoMdKey } from "react-icons/io";
import { IoChatbubblesOutline } from "react-icons/io5";
import { TbBoxModel } from "react-icons/tb";
import { TbMessageCirclePlus } from "react-icons/tb";
import { BiHide } from "react-icons/bi";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { Overlay } from '../../../components/overlay';
import { AuthorizeDialog } from '../../../dialogs/authorizedialog';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import { BillingOverview } from '../billingoverview';
import './styles.css';

export enum Display {
    Conversation,
    Models,
    Chats,
    APIKeys,
    Billing
};

interface LayoutProps {
    children?   : ReactNode;
    standalone? : boolean;
    state       : IState;
    stateLoaded : boolean;
    display     : Display;
}

interface LayoutPropsNav extends LayoutProps {
    navigate: NavigateFunction;
}

type ModelListState = {
    dropdownOpen : boolean;
    isMobile     : boolean;
    models       : IModel[];
    selected     : IModel | undefined;
    showPrompt   : boolean;
};

export class Layout extends React.Component<LayoutPropsNav, ModelListState> 
{
    state: ModelListState = {
        dropdownOpen : false,
        models       : ModelList.getModelList(),
        selected     : ModelList.selectedModel,
        isMobile     : true,
        showPrompt   : false
    };

    switchThemes() {
        const current = document.body.getAttribute('data-theme');
        if (current === 'light') {
            document.body.setAttribute('data-theme', 'dark');
        }
        else if (current === 'dark') {
            document.body.setAttribute('data-theme', 'light');
        }
    };

    componentDidMount()
    {
        ModelList.onUpdate(this.handleUpdate.bind(this));
        if (this.props.state.user !== undefined) {
            ModelList.loadModels();
        }
        window.addEventListener('resize', this.handleResize.bind(this));
        this.handleResize();
    }

    componentWillUnmount()
    {
        ModelList.removeUpdateEvent(this.handleUpdate.bind(this));
        window.removeEventListener('resize', this.handleResize.bind(this));
    }

    handleResize()
    {
        this.setState({ isMobile: window.innerWidth <= 600 });
    }

    handleLogin()
    {
        AuthorizeDialog.showDialog();
    }

    onAPIKeys()
    {
        this.props.navigate!('/playground/apikeys');
    }

    onChats()
    {
        this.props.navigate!('/playground/chats');
    }

    onConversation()
    {
        this.props.navigate!('/playground');
    }

    onModels()
    {
        this.props.navigate!('/playground/models');
    }

    onUsage()
    {
        this.props.navigate!('/playground/billing');
    }

    handleUpdate(list : IModel[], selected? : IModel)
    {
        this.setState({ models: list, selected : selected });
    }

    onShowPrompt()
    {
        this.setState({
            showPrompt : !this.state.showPrompt
        });
        this.props.navigate!('/playground');
    }

    render() {
        if (this.state.isMobile) {
            return this.renderMobile();
        }
        else {
            return this.renderDesktop();
        }
    }

    renderMobile() : ReactNode {
        const active = (this.props.state.user === undefined && this.props.stateLoaded === true);

        return (
          <Overlay active={ active }
                   message={"Please log in to continue"}
                   onClick = { () => { this.handleLogin(); }}>
            <div className="app-layout mobile">
              { this.props.display === Display.Conversation && 
              <div className="settings mobile">
                <ToolBar direction={Direction.Horizontal} >
                    <RoundButton
                        icon={IoMdAdd}
                        name="New Model"
                        onClick={() => ModelList.createModel() }/>
                    <RoundButton
                        icon={TbBoxModel}
                        name="Models"
                        onClick={() => this.onModels() }/>
                    <RoundButton
                        icon={TbMessageCirclePlus}
                        name="New Chat"
                        onClick={() => Conversation.newChat() }/>
                   <RoundButton
                        icon={IoChatbubblesOutline}
                        name="Chats"
                        onClick={() => this.onChats() }/>
                   <RoundButton
                        icon={IoChatbubblesOutline}
                        name="ApiKeys"
                        onClick={() => this.onAPIKeys() }/>
                   <RoundButton
                        icon={BiHide}
                        name="Prompt"
                        onClick={() => this.onShowPrompt() }/>
                    <RoundButton
                        icon={LiaFileInvoiceDollarSolid}
                        name="Usage"
                        onClick={() => this.onUsage()}/>
                </ToolBar>
              </div>
              }
              <main className="app-main">
                  { this.props.display === Display.Conversation &&
                    <ChatComponent mode={Mode.Mobile} showPrompt={ this.state.showPrompt }/>
                  }
                  { this.props.display === Display.Models && 
                    <ModelListComp onExit={() => this.onConversation() } />
                  }
                  { this.props.display === Display.Chats && 
                    <ChatList onExit={() => this.onConversation() }/>
                  }
                  { this.props.display === Display.APIKeys &&
                    <APIKeys state={ this.props.state } onExit={() => this.onConversation() }/>
                  }
                  {
                    this.props.display === Display.Billing &&
                    <BillingOverview onExit={() => this.onConversation() }/>
                  }
              </main>
            </div>
          </Overlay>
      );
    }

    renderDesktop() {
        const active = (this.props.state.user === undefined && this.props.stateLoaded === true);

        return (
          <Overlay active={ active }
                   message={"Please log in to continue"}
                   onClick = { () => { this.handleLogin(); }}>
            <div className="app-layout desktop">
              <div className="settings desktop">
                { this.props.standalone && <Header/> }
                <ToolBar direction={ Direction.Vertical } >
                    <ModelSelect models={this.state.models} selected={this.state.selected}/>
                    <RoundButton
                        icon={IoMdAdd}
                        name="New Model"
                        onClick={() => ModelList.createModel() }/>
                    <RoundButton
                        icon={TbBoxModel}
                        name="Models"
                        onClick={() => this.onModels() }/>
                    <RoundButton
                        icon={TbMessageCirclePlus}
                        name="New Chat"
                        onClick={() => { Conversation.newChat(); this.onConversation(); } }/>
                   <RoundButton
                        icon={IoChatbubblesOutline}
                        name="Chats"
                        onClick={() => this.onChats() }/>
                   <RoundButton
                        icon={ IoMdKey }
                        name="ApiKeys"
                        onClick={() => this.onAPIKeys() }/>
                    <RoundButton
                        icon={BiHide}
                        name="Prompt"
                        onClick={() => this.onShowPrompt() }/>
                    <RoundButton
                        icon={LiaFileInvoiceDollarSolid}
                        name="Usage"
                        onClick={() => this.onUsage()}/>
                </ToolBar>
                <footer className="app-footer" onClick={() => this.switchThemes() }>
                  <p>© {new Date().getFullYear()}</p>
                  <p className="logo-font">TigerCity.ai</p>
                </footer>
              </div>
              <main className="app-main">
                  { this.props.display === Display.Conversation &&
                    <ChatComponent mode={Mode.Desktop} showPrompt={ this.state.showPrompt }/>
                  }
                  { this.props.display === Display.Models &&
                    <ModelListComp  onExit={() => this.onConversation() } />
                  }
                  { this.props.display === Display.Chats &&
                    <ChatList onExit={() => this.onConversation() }/>
                  }
                  { this.props.display === Display.APIKeys && 
                    <APIKeys  state={ this.props.state } onExit={() => this.onConversation() }/>
                  }
                  {
                    this.props.display === Display.Billing &&
                    <BillingOverview onExit={() => this.onConversation() }/>
                  }
                </main>
            </div>
        </Overlay>
      );
    }
};

function withNavigate<P extends object>(Component: React.ComponentType<P & { navigate: NavigateFunction }>) {
    return (props: P) => <Component {...props} navigate={useNavigate()} />;
}

export default withNavigate<LayoutProps>(Layout);


